import { Button, type IButtonProps } from '~/components/button'

export function BottomSheetsBackButton({
  onPress,
  testID,
  ...props
}: Omit<IButtonProps, 'children'>) {
  return (
    <Button.Root
      {...props}
      variant="neutral-tertiary"
      size="md"
      testID={testID}
      onPress={onPress}
    >
      <Button.Icon symbol="rdicon-chevron-left" />
    </Button.Root>
  )
}
